import { mapGetters, mapActions } from 'vuex'
import SchedulingTypeModule, { MODULE_NAME } from './index'

const SchedulingTypeMixin = {
  namespaced: SchedulingTypeModule.namespaced,
  computed: { ...mapGetters(MODULE_NAME, Object.keys(SchedulingTypeModule.getters)) },
  methods: { ...mapActions(MODULE_NAME, Object.keys(SchedulingTypeModule.actions)) }
}

export default SchedulingTypeMixin



// WEBPACK FOOTER //
// ./src/store/module/schedulingtype/mixin.js